import { KdsDivider, KdsText } from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill, RiCloseCircleFill } from "@remixicon/react";

import { type OrderItemPageActivityLogStepProps } from "./OrderItemPageActivityLogStep.types";

export const OrderItemPageActivityLogStep = (
  props: OrderItemPageActivityLogStepProps
) => {
  return (
    <div className="flex items-center gap-sp-xs p-sp-xs">
      {props.blocked ? (
        <RiCloseCircleFill className="w-6 min-w-6 text-error-main" />
      ) : (
        <RiCheckboxCircleFill className="w-6 min-w-6 text-success-main" />
      )}

      <div className="whitespace-nowrap">
        <KdsText size="subtitle-sm" color="text-bodyvariant">
          {props.label}
        </KdsText>
      </div>

      <KdsDivider />

      <div className="whitespace-nowrap">
        <KdsText size="caption-sm" color="text-bodyvariant">
          {props.createdAt}
        </KdsText>
      </div>
    </div>
  );
};
